'use strict';
module.exports = function teamProviderClass(provider) {
	if (provider && provider !== 'mindmup-auto') {
		return provider;
	} else {
		return 'icon-teams';
	}
};
